// extracted by mini-css-extract-plugin
export default {"link":"GeofenceImportPanel_link__PS0bJ"};